export interface CancellationReason {
  id: number;
  tenantId: string | null;
  reasonText: string;
  userFacingMessage: string | null;
  displayOrder: number;
  active: boolean;
  usageCount: number | null;
}

export interface CancellationReasonPayload {
  reason_text: string;
  user_facing_message?: string | null;
  tenant_id: string | null;
  active: boolean;
}

export interface CancelEventPayload {
  eventId: number;
  reasonId: number;
  internalNote?: string | null;
}

export interface EventCancellationDetail {
  cancelledAt: string;
  internalNote: string | null;
  affectedUsers: number;
  affectedCompanions: number;
  requiresRefund: boolean;
  reasonText: string;
  cancelledByName: string;
  cancelledByRole: string | null;
}

export interface EventCancellationListItem extends EventCancellationDetail {
  id: number;
  eventId: number;
  eventName: string;
  tenantId: string;
}

export interface EventCancellationsFilters {
  tenantId?: string | null;
  reasonIds?: number[];
  from: string;
  to: string;
  page?: number;
  perPage?: number;
}

export interface EventCancellationsPage {
  items: EventCancellationListItem[];
  total: number;
  page: number;
  perPage: number;
}

export interface EventCancellationsSummary {
  totalCancellations: number;
  topReasonText: string | null;
  topReasonCount: number;
  affectedUsers: number;
}

export const isOtherReason = (reasonText: string | undefined): boolean =>
  (reasonText ?? "").trim().toLowerCase().startsWith("otro");

export const CANCELLATION_INTERNAL_NOTE_MAX_LENGTH = 500;

export const formatAffectedInscriptions = (
  affectedUsers: number,
  affectedCompanions: number
): string => {
  const total = affectedUsers + affectedCompanions;
  if (affectedCompanions > 0) {
    return `${total} (${affectedUsers} inscriptos + ${affectedCompanions} acompañantes)`;
  }
  return String(total);
};
